import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchClass, editClassDate,
} from "Actions/Admin/Strech/ClassActions";



/**
 * The Strech Class Date Dialog
 */
class ClassDate extends React.Component {
    // The Initial Data
    initialData = {
        strechClassID : 0,
        strechID      : 0,
        timeDate      : "",
        fromHour      : "",
        toHour        : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchClass } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchClass(elemID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition && elemID) {
            data = Utils.extend(this.initialData, elem);
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editClassDate(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { open, onClose         } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="class"
            title="CLASSES_DATE_TITLE"
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="date"
                name="timeDate"
                label="CLASSES_DATE"
                value={data.timeDate}
                error={errors.timeDate}
                onChange={this.handleChange}
                isRequired
            />
            <Columns>
                <InputField
                    type="time"
                    name="fromHour"
                    label="GENERAL_FROM_HOUR"
                    value={data.fromHour}
                    error={errors.fromHour}
                    onChange={this.handleChange}
                    isRequired
                />
                <InputField
                    type="time"
                    name="toHour"
                    label="GENERAL_TO_HOUR"
                    value={data.toHour}
                    error={errors.toHour}
                    onChange={this.handleChange}
                    isRequired
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchClass    : PropTypes.func.isRequired,
        editClassDate : PropTypes.func.isRequired,
        open          : PropTypes.bool.isRequired,
        onClose       : PropTypes.func.isRequired,
        onSubmit      : PropTypes.func.isRequired,
        edition       : PropTypes.number.isRequired,
        elem          : PropTypes.object.isRequired,
        elemID        : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition : state.strechClass.edition,
            elem    : state.strechClass.elem,
        };
    }
}

export default connect(ClassDate.mapStateToProps, {
    fetchClass, editClassDate,
})(ClassDate);
